/*
  Moda Loca - "Ηλεκτρονική πληρωμή" button on the product page.
  Added 2026-08-12.

  WHY THIS EXISTS
  Shopify gives the product page exactly one buy-now slot and fills it with a
  wallet button (Shop Pay / PayPal / Google Pay) whenever the shopper has one.
  It only falls back to the plain card button when no wallet exists at all.
  There is no setting for this. So to show a card button without disabling the
  wallets, we add our own: it posts the current variant to the cart and sends
  the shopper straight to checkout.

  LOADED FROM snippets/meta-tags.liquid.

  SCOPE
  Only the main product form is touched - identified by the presence of
  .shopify-payment-button inside .product-form__buttons. Collection cards and
  quick-view forms do not have it, so they are left alone.

  ORDER
  The COD app (Releasit) injects ._rsi-buy-now-button after page load, so we
  keep re-checking for a few seconds and move our button above it. Final order:
  Add to cart / Card / COD / More payment options.

  LABEL CASE
  The theme's .btn class forces text-transform: uppercase. We override it to
  none so the label reads exactly as written, matching the COD button beside
  it. Delete the text-transform declaration to get the theme's uppercase look.
*/
(function () {
  'use strict';

  var LABEL = 'Ηλεκτρονική πληρωμή';
  var BUSY = 'Μετάβαση στο ταμείο...';
  var ERR_TERMS = 'Παρακαλώ αποδέξου τους Όρους & Προϋποθέσεις.';
  var ERR_GENERIC = 'Κάτι πήγε στραβά. Δοκίμασε ξανά.';

  var BTN_STYLE = 'width:100%;background:#ffffff;color:#111111;border:0;text-transform:none;';

  function build(container) {
    if (!container || container.querySelector('.ml-card-buy')) { return; }
    if (!container.querySelector('.shopify-payment-button')) { return; }

    var form = container.closest('form[action*="/cart/add"]');
    if (!form) { return; }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn ml-card-buy';
    btn.textContent = LABEL;
    btn.style.cssText = BTN_STYLE;

    var msg = document.createElement('p');
    msg.className = 'ml-card-buy__msg';
    msg.setAttribute('aria-live', 'polite');
    msg.style.cssText = 'color:#ff6b6b;font-size:14px;margin:6px 0 0;';

    var anchor = container.querySelector('._rsi-buy-now-button')
      || container.querySelector('.shopify-payment-button');

    container.insertBefore(btn, anchor);
    container.insertBefore(msg, anchor);

    btn.addEventListener('click', function () {
      var terms = container.querySelector('input[type="checkbox"]');
      if (terms && !terms.checked) {
        msg.textContent = ERR_TERMS;
        try { terms.focus(); } catch (e) {}
        return;
      }

      msg.textContent = '';
      btn.disabled = true;
      btn.textContent = BUSY;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (j) {
              throw new Error(j.description || j.message || '');
            });
          }
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function (e) {
          btn.disabled = false;
          btn.textContent = LABEL;
          msg.textContent = (e && e.message) ? e.message : ERR_GENERIC;
        });
    });
  }

  // If the COD button arrives after ours, put ours back on top.
  function reorder(container) {
    var btn = container.querySelector('.ml-card-buy');
    var msg = container.querySelector('.ml-card-buy__msg');
    var cod = container.querySelector('._rsi-buy-now-button');
    if (!btn || !cod) { return; }
    var codComesFirst = btn.compareDocumentPosition(cod) & Node.DOCUMENT_POSITION_PRECEDING;
    if (codComesFirst) {
      container.insertBefore(btn, cod);
      if (msg) { container.insertBefore(msg, cod); }
    }
  }

  function scan() {
    var nodes = document.querySelectorAll('.product-form__buttons');
    for (var i = 0; i < nodes.length; i++) {
      build(nodes[i]);
      reorder(nodes[i]);
    }
  }

  function start() {
    scan();
    var tries = 0;
    var timer = setInterval(function () {
      scan();
      if (++tries > 20) { clearInterval(timer); }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
